import useWindowDimensions from "_hooks/useWindowDimensions";

const GoogleAdTop = ({ className }) => {
  const { width } = useWindowDimensions();

  const showGoogleAdScriptTop = () => {
    if (width > 0 && width < 640) {
      return (
        <>
          <script
            async
            src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-1690314786863972"
            crossorigin="anonymous"
          ></script>

          <ins
            className="adsbygoogle"
            style={{ display: "inline-block", width: "450px", height: "250px" }}
            data-ad-client="ca-pub-1690314786863972"
            data-ad-slot="8403655196"
          ></ins>
          <script>{`(adsbygoogle = window.adsbygoogle || []).push({});`}</script>
        </>
      );
    } else if (width > 640 && width < 1024) {
      return (
        <>
          <script
            async
            src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-1690314786863972"
            crossorigin="anonymous"
          ></script>
          <ins
            className="adsbygoogle"
            style={{ display: "inline-block", width: "720px", height: "90px" }}
            data-ad-client="ca-pub-1690314786863972"
            data-ad-slot="2900310407"
          ></ins>
          <script>{`(adsbygoogle = window.adsbygoogle || []).push({});`}</script>
        </>
      );
    } else if (width > 1024) {
      return (
        <>
          <script
            async
            src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-1690314786863972"
            crossorigin="anonymous"
          ></script>
          <ins
            className="adsbygoogle"
            style={{
              display: "inline-block",
              width: "1000px",
              height: "250px",
            }}
            data-ad-client="ca-pub-1690314786863972"
            data-ad-slot="9661445287"
          ></ins>
          <script>{`(adsbygoogle = window.adsbygoogle || []).push({});`}</script>
        </>
      );
    }
  };

  return (
    <div
      className={`flex justify-center mx-auto mb-5 ${
        className ? className : ""
      }`}
    >
      {showGoogleAdScriptTop()}
    </div>
  );
};

export default GoogleAdTop;
